/**
 * Scripts
 */
import 'vite/modulepreload-polyfill'
import 'lazysizes'
import { startupTheme } from './js/theme'
import { startRouter } from './js/app/router'
import { startClock } from './js/clock'
import { startNav } from './js/nav'
import { startEasyMode } from './js/easyMode'
import { startSound } from './js/sound'
import { startChat } from './js/chat'
import { startMobileNav } from './js/mobileNav'
import { startScrollState } from './js/scrollState'

// Page modules — each registers itself with onPage() (see js/app/lifecycle.js)
import './js/background'
import './js/blocks/snake/index'
import './js/blocks/pizzaSlider'
import './js/blocks/faqSlider'
import './js/blocks/menuSlider'

import './js/cookieBanner'

import './sass/main.sass'

/**
 * Start Theme
 */
startupTheme()
startClock()
startNav()
startMobileNav()
startScrollState()
startEasyMode()
startSound()
startChat()
// Last: mounts the page modules for the initial page, then hands links to Swup.
startRouter()
